const HRU_PRODUCTS = [
  {
    id: 'BHRU-1000',
    brand: 'BOREAS',
    model: 'BHRU-1000',
    type: 'Standart',
    flow: 1000,
    image: '/images/hru/boreas_bhru.jpg',
    catalog: '/images/hru/boreas-bhru-1000.png'
  },
  {
    id: 'BHRU-2000',
    brand: 'BOREAS',
    model: 'BHRU-2000',
    type: 'Standart',
    flow: 2000,
    image: '/images/hru/boreas_bhru.jpg',
    catalog: '/images/hru/boreas-bhru-2000.png'
  },
  {
    id: 'BHRU-3000',
    brand: 'BOREAS',
    model: 'BHRU-3000',
    type: 'Standart',
    flow: 3000,
    image: '/images/hru/boreas_bhru.jpg',
    catalog: '/images/hru/boreas-bhru-3000.png'
  },
  {
    id: 'BHRU-4000',
    brand: 'BOREAS',
    model: 'BHRU-4000',
    type: 'Standart',
    flow: 4000,
    image: '/images/hru/boreas_bhru.jpg',
    catalog: '/images/hru/boreas-bhru-4000.png'
  },
  {
    id: 'BHRU-5000',
    brand: 'BOREAS',
    model: 'BHRU-5000',
    type: 'Standart',
    flow: 5000,
    image: '/images/hru/boreas_bhru.jpg',
    catalog: '/images/hru/boreas-bhru-5000.png'
  },

  // ✅ Kayıtes Ürünleri
  {
    id: 'IGK-10',
    brand: 'KAYITES',
    model: 'IGK-10',
    type: 'Standart',
    flow: 1000,
    image: '/images/hru/kayites-igk.png',
    catalog: '/images/hru/kayites-igk-10.jpg'
  },
  {
    id: 'IGK-20',
    brand: 'KAYITES',
    model: 'IGK-20',
    type: 'Standart',
    flow: 2000,
    image: '/images/hru/kayites-igk.png',
    catalog: '/images/hru/kayites-igk-20.jpg'
  },
  {
    id: 'IGK-30',
    brand: 'KAYITES',
    model: 'IGK-30',
    type: 'Standart',
    flow: 3000,
    image: '/images/hru/kayites-igk.png',
    catalog: '/images/hru/kayites-igk-30.jpg'
  },
  {
    id: 'IGK-40',
    brand: 'KAYITES',
    model: 'IGK-40',
    type: 'Standart',
    flow: 4000,
    image: '/images/hru/kayites-igk.png',
    catalog: '/images/hru/kayites-igk-40.jpg'
  },
  {
    id: 'IGK-50',
    brand: 'KAYITES',
    model: 'IGK-50',
    type: 'Standart',
    flow: 5000,
    image: '/images/hru/kayites-igk.png',
    catalog: '/images/hru/kayites-igk-50.jpg'
  },
  // ✅ Viaclimate Standart HRUBOX
  /*
  {
    id: 'HRUBOX-1000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX 1000',
    type: 'Standart',
    flow: 1000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-spect.png'
  },
  {
    id: 'HRUBOX-2000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX 2000',
    type: 'Standart',
    flow: 2000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-spect.png'
  },
  {
    id: 'HRUBOX-3000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX 3000',
    type: 'Standart',
    flow: 3000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-spect.png'
  },
  {
    id: 'HRUBOX-4000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX 4000',
    type: 'Standart',
    flow: 4000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-spect.png'
  },
  {
    id: 'HRUBOX-5000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX 5000',
    type: 'Standart',
    flow: 5000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-spect.png'
  }, 
*/
  // ✅ Viaclimate EC HRUBOX
  {
    id: 'HRUBOX-EC-750',
    brand: 'VIACLIMATE',
    model: 'HRUBOX EC 750',
    type: 'Standart',
    flow: 750,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-ec-spect.png'
  },
  {
    id: 'HRUBOX-EC-1000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX EC 1000',
    type: 'Standart',
    flow: 1000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-ec-spect.png'
  },
  {
    id: 'HRUBOX-EC-1500',
    brand: 'VIACLIMATE',
    model: 'HRUBOX EC 1500',
    type: 'Standart',
    flow: 1500,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-ec-spect.png'
  },
  {
    id: 'HRUBOX-EC-2000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX EC 2000',
    type: 'Standart',
    flow: 2000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-ec-spect.png'
  },
  {
    id: 'HRUBOX-EC-2500',
    brand: 'VIACLIMATE',
    model: 'HRUBOX EC 2500',
    type: 'Standart',
    flow: 2500,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-ec-spect.png'
  },
  {
    id: 'HRUBOX-EC-3000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX EC 3000',
    type: 'Standart',
    flow: 3000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-ec-spect.png'
  },
  {
    id: 'HRUBOX-EC-4000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX EC 4000',
    type: 'Standart',
    flow: 4000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-ec-spect.png'
  },
  {
    id: 'HRUBOX-EC-5000',
    brand: 'VIACLIMATE',
    model: 'HRUBOX EC 5000',
    type: 'Standart',
    flow: 5000,
    image: '/images/hru/viaclimate_hrubox.png',
    catalog: '/images/hru/viaclimate-hrubox-ec-spect.png'
  },
  // ✅ Viaclimate EC HRUBOX DX (Bataryalı)
{
  id: 'HRUBOX-EC-DX-750',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC DX 750',
  type: 'Bataryalı',
  flow: 750,
  image: '/images/hru/viaclimate_hrubox-dx.jpg',
  catalog: '/images/hru/viaclimate-hrubox-ec-dx-spect.png'
},
{
  id: 'HRUBOX-EC-DX-1000',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC DX 1000',
  type: 'Bataryalı',
  flow: 1000,
  image: '/images/hru/viaclimate_hrubox-dx.jpg',
  catalog: '/images/hru/viaclimate-hrubox-ec-dx-spect.png'
},
{
  id: 'HRUBOX-EC-DX-1500',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC DX 1500',
  type: 'Bataryalı',
  flow: 1500,
  image: '/images/hru/viaclimate_hrubox-dx.jpg',
  catalog: '/images/hru/viaclimate-hrubox-ec-dx-spect.png'
},
{
  id: 'HRUBOX-EC-DX-2000',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC DX 2000',
  type: 'Bataryalı',
  flow: 2000,
  image: '/images/hru/viaclimate_hrubox-dx.jpg',
  catalog: '/images/hru/viaclimate-hrubox-ec-dx-spect.png'
},
{
  id: 'HRUBOX-EC-DX-2500',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC DX 2500',
  type: 'Bataryalı',
  flow: 2500,
  image: '/images/hru/viaclimate_hrubox-dx.jpg',
  catalog: '/images/hru/viaclimate-hrubox-ec-dx-spect.png'
},
{
  id: 'HRUBOX-EC-DX-3000',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC DX 3000',
  type: 'Bataryalı',
  flow: 3000,
  image: '/images/hru/viaclimate_hrubox-dx.jpg',
  catalog: '/images/hru/viaclimate-hrubox-ec-dx-spect.png'
},
{
  id: 'HRUBOX-EC-DX-4000',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC DX 4000',
  type: 'Bataryalı',
  flow: 4000,
  image: '/images/hru/viaclimate_hrubox-dx.jpg',
  catalog: '/images/hru/viaclimate-hrubox-ec-dx-spect.png'
},

// ✅ Viaclimate EC HRUBOX HP (Kompresörlü)
{
  id: 'HRUBOX-EC-HP-750',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC HP 750',
  type: 'Kompresörlü',
  flow: 750,
  image: '/images/hru/viaclimate_hrubox.png',
  catalog: '/images/hru/viaclimate-hrubox-ec-hp-spect.png'
},
{
  id: 'HRUBOX-EC-HP-1000',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC HP 1000',
  type: 'Kompresörlü',
  flow: 1000,
  image: '/images/hru/viaclimate_hrubox.png',
  catalog: '/images/hru/viaclimate-hrubox-ec-hp-spect.png'
},
{
  id: 'HRUBOX-EC-HP-1500',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC HP 1500',
  type: 'Kompresörlü',
  flow: 1500,
  image: '/images/hru/viaclimate_hrubox.png',
  catalog: '/images/hru/viaclimate-hrubox-ec-hp-spect.png'
},
{
  id: 'HRUBOX-EC-HP-2000',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC HP 2000',
  type: 'Kompresörlü',
  flow: 2000,
  image: '/images/hru/viaclimate_hrubox.png',
  catalog: '/images/hru/viaclimate-hrubox-ec-hp-spect.png'
},
{
  id: 'HRUBOX-EC-HP-2500',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC HP 2500',
  type: 'Kompresörlü',
  flow: 2500,
  image: '/images/hru/viaclimate_hrubox.png',
  catalog: '/images/hru/viaclimate-hrubox-ec-hp-spect.png'
},
{
  id: 'HRUBOX-EC-HP-3000',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC HP 3000',
  type: 'Kompresörlü',
  flow: 3000,
  image: '/images/hru/viaclimate_hrubox.png',
  catalog: '/images/hru/viaclimate-hrubox-ec-hp-spect.png'
},
{
  id: 'HRUBOX-EC-HP-4000',
  brand: 'VIACLIMATE',
  model: 'HRUBOX EC HP 4000',
  type: 'Kompresörlü',
  flow: 4000,
  image: '/images/hru/viaclimate_hrubox.png',
  catalog: '/images/hru/viaclimate-hrubox-ec-hp-spect.png'
}


];

export default HRU_PRODUCTS;
